/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import useResetPasswordLandingFields from './useResetPasswordLandingFields'
import Field from '../../field'
import PasswordRequirements from '../password-requirements'

const ResetPasswordLandingFields = ({form, prefix = '', email = ''}) => {
    const fields = useResetPasswordLandingFields({form, prefix})
    const password = form.watch('password')

    return (
        <Stack>
            <Stack display="none">
                <Field {...fields.email} readOnly={true} />
            </Stack>
            <Field {...fields.password} />
            <PasswordRequirements value={password} />
            <Field {...fields.confirmPassword} />
        </Stack>
    )
}

ResetPasswordLandingFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,
    /** Optional prefix for field names */
    prefix: PropTypes.string,
    /** Email value from URL */
    email: PropTypes.string
}

export default ResetPasswordLandingFields
